import RoleHome from '../RoleHome';

export default function PorterPage() {
  return (
    <RoleHome
      title="Porter"
      description="Patient transport and related queue items."
    />
  );
}
